import { useState } from "react";
import { Send, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import axios from "axios";

const API = "/api";

export default function ContactForm({ propertyReference = null, propertyTitle = null }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: propertyTitle 
      ? `Bonjour,\n\nJe suis intéressé(e) par le bien "${propertyTitle}" (Réf: ${propertyReference}).\n\nMerci de me recontacter pour plus d'informations.`
      : ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/contact`, {
        ...formData,
        property_reference: propertyReference
      });
      
      toast.success("Message envoyé avec succès ! Nous vous recontacterons rapidement.");
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: ""
      });
    } catch (error) {
      console.error("Error sending contact:", error);
      toast.error("Erreur lors de l'envoi du message. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5" data-testid="contact-form">
      <div className="space-y-2">
        <Label htmlFor="name" className="text-sm font-medium text-zinc-700">
          Nom complet *
        </Label>
        <Input
          id="name"
          name="name"
          type="text"
          required
          value={formData.name}
          onChange={handleChange}
          placeholder="Votre nom"
          className="rounded-none border-zinc-200 focus:ring-1 focus:ring-[#D62965] focus:border-[#D62965]"
          data-testid="contact-name-input"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="email" className="text-sm font-medium text-zinc-700">
          Email *
        </Label>
        <Input
          id="email"
          name="email"
          type="email"
          required
          value={formData.email}
          onChange={handleChange}
          placeholder="votre@email.com"
          className="rounded-none border-zinc-200 focus:ring-1 focus:ring-[#D62965] focus:border-[#D62965]"
          data-testid="contact-email-input"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="phone" className="text-sm font-medium text-zinc-700">
          Téléphone
        </Label>
        <Input
          id="phone"
          name="phone"
          type="tel"
          value={formData.phone}
          onChange={handleChange}
          placeholder="06 XX XX XX XX"
          className="rounded-none border-zinc-200 focus:ring-1 focus:ring-[#D62965] focus:border-[#D62965]"
          data-testid="contact-phone-input"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="message" className="text-sm font-medium text-zinc-700">
          Message *
        </Label>
        <Textarea
          id="message"
          name="message"
          required
          value={formData.message}
          onChange={handleChange}
          placeholder="Votre message..."
          rows={5}
          className="rounded-none border-zinc-200 focus:ring-1 focus:ring-[#D62965] focus:border-[#D62965] resize-none"
          data-testid="contact-message-input"
        />
      </div>

      <Button
        type="submit"
        disabled={loading}
        className="w-full bg-[#D62965] hover:bg-[#A61E4E] text-white rounded-none px-6 py-3 font-medium transition-all duration-200"
        data-testid="contact-submit-btn"
      >
        {loading ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Envoi en cours...
          </>
        ) : (
          <>
            <Send className="mr-2 h-4 w-4" />
            Envoyer le message
          </>
        )}
      </Button>
    </form>
  );
}
